<template>
  <div class="list-box" v-loading="loading">
    <template v-if="listType === 'info'">
      <NewsInfo :inList="true" v-if="dataList[0]" :queryId="dataList[0].id" />
    </template>
    <template v-else-if="listType === 'default'">
      <news-card v-for="item in dataList" :key="item.id" :news="item" />
    </template>
    <template v-else-if="listType === 'img'">
      <div class="img-list">
        <img-news-card :imgStyle="imgStyle" v-for="item in dataList" :key="item.id" :news="item" />
      </div>
    </template>
    <template v-else-if="listType === 'form'">
      <form-news-card :list="dataList" @search="pageNum = 1; queryNewsList($event)" />
    </template>
    <el-pagination
      v-if="showPagination"
      class="pagination-box"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-size="pageSize"
      layout="prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import NewsCard from '@/components/NewsCard.vue'
import ImgNewsCard from '@/components/ImgNewsCard.vue'
import FormNewsCard from '@/components/FormNewsCard.vue'
import NewsInfo from '@/components/NewsInfo.vue'
import { getMenuListTypeById } from "@/config/menus";
import { newsList } from "@/api/apis";

export default {
  name: "List",
  components: {
    NewsCard,
    ImgNewsCard,
    FormNewsCard,
    NewsInfo,
  },
  data() {
    return {
      loading: false,
      listType: "",
      pageNum: 1,
      pageSize: 5,
      total: 0,
      dataList: [],
      imgStyle: {
        width: "206px",
        height: "155px",
      },
      //查询条件
      queryParams: {}
    }
  },
  watch: {
    "$route": {
      immediate: true,
      handler(v) {
        // 搜索
        if(v.name === "search" && this.$route.query.keyword) {
          this.queryParams = {
            newsContent: this.$route.query.keyword
          }
        } else {
          this.queryParams = {}
        }
        this.onloadOrRoute();
      }
    }
  },
  computed: {
    showPagination() {
      return this.total > this.pageSize;
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.queryNewsList(this.queryParams)
    },
    onloadOrRoute() {
      this.dataList = []
      this.total = 0
      this.$nextTick(() => {
        this.listType = getMenuListTypeById(sessionStorage.getItem("asideActiveId")) || "default";
        if(this.listType === "img") {
          this.pageSize = 6;
        } else {
          this.pageSize = 5;
        }
        this.pageNum = 1;
        this.queryNewsList(this.queryParams);
      })
    },
    queryNewsList(params = {}) {
      this.loading = true
      this.queryParams = params
      const asideActiveId = sessionStorage.getItem("asideActiveId")
      if(!asideActiveId) {
        alert("请先选择菜单");
        this.loading = false
        return;
      }
      newsList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        newsMenuId: asideActiveId === "local001001" ? "" : asideActiveId,
        ...params
      }).then(res => {
        if(res.code === 200) {
          this.dataList = res.rows || [];
          this.total = res.total || 0;
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-box ::v-deep {
  .pagination-box {
    text-align: right;
    margin-top: 20px;
  }
  .img-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .img-news-card {
      margin: 20px 30px 0 0;
      width: 210px;
      height: 300px;
      .img-box {
        width: 210px;
        height: 160px;
        overflow: hidden;
      }
    }
  }
}
</style>